import React from 'react'
import { Field, Topics } from './'

import { RESOURCE_GRID } from '../../../../lib/constants'

let resourceLinks  = [
	"https://mailchimp.com/",

	"https://mailchimp.com/courier/",

	"https://mailchimp.com/presents/"
	
	
];

const ResourceListItem = ({ index, data, last, hovered, setHovered }) => {
	// add urls to backend in resources


	return (
		<div
			className='resource'
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<div className='title'>
				<a href={[resourceLinks[index - 1]]}>
					<Field sanSerif bold className='field-title'>{data.resource}</Field>
				</a>
			</div>

			<div className='info'>
				<Field sanSerif className='field-info'>{data.info}</Field>
			</div>

			<div className='tops'>
				<Topics {...data} />
			</div>

			<style jsx>{`
				a {
					color: black;
				}

				.resource {
					display: grid;
					grid-template-columns: ${RESOURCE_GRID};
					width: 100%;
					padding: 1.25rem 0;

					border-bottom: ${last ? 0 : '1px solid black'};
					padding-bottom: 3rem;
				}

				@media (max-width: 768px), (pointer: coarse) {
					.resource {
						display: block;
						padding: 1.25rem 0;
					}

					.title {
						margin-bottom: 15px;
					}

					.title :global(.field-title) {
						font-size: 26px;
					}
					.title :global(.field-info) {
						font-size: 20px;
					}

					.tops :global(.topic) {
						margin-bottom: 10px;
					}
					.info {
						margin-bottom: 30px;
					}
				}
			`}</style>
		</div>


	)
}

export default ResourceListItem
